import DraggableStepCard from '../DraggableStepCard';

export const content = ({ step }) => step?.description;

export const getDescription = ({ step, t }) =>
  step?.isBranchGroupInitiator
    ? t('Run Branches in Parallel, then Merge')
    : t('Run Branches in Parallel');

export default function BranchCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
